/* global confirm */

import React, { Fragment } from 'react';
import { __ } from 'i18n-for-browser';
import { connect } from 'react-redux';

import GoBackButton from '../elements/GoBackButton';
import ContentContainer from '../elements/ContentContainer';
import Switch from '../elements/Switch';
import GameMaterials from '../elements/GameMaterials';
import GroupRow from '../elements/GroupRow';
import actions from '../../actions';
import { UPDATE_HANDLING_ROUND_STATE_CHANGE } from '../../actions/types';
import PopUp from "../../components/elements/PopUp";
import apiCall from "../apiCall";
import PopupTitle from "../elements/PopupTitle";
import { dispatchUnreadPopup, getPopupDeviceDifficulty } from "../../helpers/popupHelper";

const { setRoundState } = actions.gameState;
const { updatePopups } = actions.popup;

class Verdienen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gameMaterials: [],
    };
    this.gameId = parseInt(this.props.match.params.gameId, 10);
    this.deviceAndDifficulty = getPopupDeviceDifficulty(this.props.gameState.DefaultDifficultyId);
  }

  componentDidMount() {
    const { dispatch, project, gameState } = this.props;
    const currentRound = (gameState.Rounds ? gameState.Rounds.length - 1 : 1);
    if(currentRound <= 1) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'dhbvtintro_landbesturen_T' : 'dlbvtintro_landbesturen_T'), dispatch);
    }
  }

  get currentRound() {
    const { gameState } = this.props;
    return gameState.loaded ? gameState.roundData : {};
  }

  get status() {
    return this.currentRound.state;
  }

  componentWillMount() {
    this.fetchGeneralMaterials();
  }

  isFeedbackActive = () => {
   return this.status === 'SIMULATION_START' || this.isVerdelenActive() || this.status === 'SIMULATION_SPENDING';
  };

  isVerdelenActive = () => {
    return this.status === 'SIMULATION_TAX' || this.status === 'SIMULATION_TAX_2' || this.status === 'SIMULATION_SPENDING';
  };

  isSpendingActive = () => {
    return this.currentRound.step3Active;
  };

  confirmEnd = () => {
    this.props.dispatch(setRoundState('END'));
    this.setState({confirmEnd: false});
  };

  loginAsGroup = (groupId) => {
    apiCall(`/user/${groupId}/loginAsGroup`, {}, 'POST')
      .then((access) => {
        window.open(`/login?token=${access.token}&redirect=/`);
      });
  };

  fetchGeneralMaterials = () => {
    const { project, schoolClass } = this.props;
    apiCall(`/generalMaterial/${schoolClass.LanguageId}/${project.DefaultDifficultyId}/1`)
      .then((gameMaterials) => {
        this.setState({ gameMaterials });
      });
  };

  render() {
    const { project, schoolClass, gameState } = this.props;
    if (!project.loaded || !schoolClass.loaded || !gameState.loaded) return null;
    const verdelenActiverenIsDisabled = !this.isFeedbackActive() || this.isVerdelenActive() || gameState.endOfGame;
    const spendingActiverenIsDisabled = !this.isFeedbackActive() || !this.isVerdelenActive() || this.isSpendingActive() || gameState.endOfGame;
    const finalSituation = (this.props.gameState.currentRound === 4 && this.status === "END") || this.props.gameState.currentRound === 5;
    return (
      <div className={`verdelen-desktop portal-verdelen classleader-portal${(this.props.desktop ? ' portal-home darkBckg' : '')}`}>
        <div className={'container list-item-container'}>
          <div className={'title-block'}>
            <GoBackButton history={this.props.history} />
            <PopupTitle popupId={`${this.deviceAndDifficulty}bvtintro_landbesturen`} title={__('sim_land_besturen')} tag={'h3'}/>
            <p>{__('sim_globas_verdelen')}</p>
          </div>
          <div className={'column-portal'}>
            <div className="content-block">
              <div className={'title-container'}>
                <PopupTitle popupId={`${this.deviceAndDifficulty}bvtverdelenspel`} tag={'h3'}/>
              </div>
              <ContentContainer className={!this.props.gameState.allowFeedbackActivate ? 'disabled' : ''}>
                <div className={'title-container'}>
                  {(finalSituation) ? (
                      <PopupTitle popupId={`${this.deviceAndDifficulty}bvtfeedbackactiveren_1`} tag={'p'}/>
                    ) : (
                      <PopupTitle popupId={`${this.deviceAndDifficulty}bvtfeedbackactiveren`} tag={'p'}/>
                    )}
                </div>
                <Switch
                  checked={this.isFeedbackActive()}
                  disabled={this.props.gameState.handlingRoundStateChange}
                  onChange={() => {
                    if (!this.props.gameState.allowFeedbackActivate) return;
                    this.props.dispatch(setRoundState('SIMULATION_START'));
                  }}
                  preConditions={() => {
                    if (!this.props.gameState.allowFeedbackActivate) {
                        if (this.status && this.status.startsWith("SIMULATION_")) {
                          this.props.dispatch(updatePopups({ popupId: `${this.deviceAndDifficulty}bmfeedbackactiveren`, closeable: true, tutorial: false }));
                        } else {
                          this.props.dispatch(updatePopups({ popupId: `dhbmfeedbackactiveren_0`, closeable: true, tutorial: false }));
                        }
                      return false;
                    }
                    return true;
                  }}
                />
              </ContentContainer>
            </div>
            <div className="content-block">
              {finalSituation ? null : (
                <Fragment>
                  <ContentContainer className={ verdelenActiverenIsDisabled ? 'disabled' : ''}>
                    <div className={'title-container'}>
                      <PopupTitle popupId={`${this.deviceAndDifficulty}bvtverdelenactiveren`} tag={'p'}/>
                    </div>
                    <span>
                  <Switch
                    checked={this.isVerdelenActive()}
                    disabled={this.props.gameState.handlingRoundStateChange}
                    ignoreDisabled={true}
                    onChange={() => {
                      if (verdelenActiverenIsDisabled) return;
                      this.setState({ confirmPopup: { action: () => {
                            this.props.dispatch(setRoundState('SIMULATION_TAX'));
                          }, name: `${this.deviceAndDifficulty}bmverdelenactiveren_1a` } });
                      return false;
                    }}
                    preConditions={() => {
                      if (verdelenActiverenIsDisabled) {
                        if (!this.status || this.status === 'PLAYING_GAME' || "SCORE_SUBMITTED" && !this.isVerdelenActive()) {
                          this.props.dispatch(updatePopups({ popupId: `${this.deviceAndDifficulty}bmverdelenactiveren_1`, closeable: true, tutorial: false }));
                        } else {
                          this.props.dispatch(updatePopups({ popupId: `${this.deviceAndDifficulty}bmverdelenactiveren_2`, closeable: true, tutorial: false }));
                        }
                        return false;
                      }
                      return true;
                    }}
                  />
                </span>
                  </ContentContainer>
                  <ContentContainer className={spendingActiverenIsDisabled ? 'disabled' : ''}>
                    <div className={'title-container'}>
                      <PopupTitle popupId={`${this.deviceAndDifficulty}bvtverdelenactiveren_1`} tag={'p'}/>
                    </div>
                    <span>
                  <Switch
                    checked={this.isSpendingActive()}
                    disabled={this.props.gameState.handlingRoundStateChange}
                    ignoreDisabled={true}
                    onChange={async () => {
                      if (spendingActiverenIsDisabled) return;
                      this.setState({
                        confirmPopup: {
                          name: `${this.deviceAndDifficulty}bmstap3activeren_1a`,
                          action: async () => {
                            this.props.dispatch({ type: UPDATE_HANDLING_ROUND_STATE_CHANGE, payload: true });
                            await apiCall(`/simulatiespel/activateStepThree/${this.props.schoolClass.id}/${this.currentRound.roundNumber}`, null, 'POST');
                          },
                        },
                      });
                    }}
                    preConditions={() => {
                      if(this.isSpendingActive()) {
                        this.props.dispatch(updatePopups({ popupId: `${this.deviceAndDifficulty}bmstap3activeren_2`, closeable: true, tutorial: false }));
                        return false;
                      }
                      if (spendingActiverenIsDisabled) {
                        this.props.dispatch(updatePopups({ popupId: `${this.deviceAndDifficulty}bmstap3activeren_1`, closeable: true, tutorial: false }));
                        return false;
                      }
                      return true;
                    }}
                  />
                </span>
                  </ContentContainer>
                </Fragment>
              )}
              <div className="spacing-20" />
            </div>
            <div className="content-block content-block--small">
              <div className={'title-container'}>
                <PopupTitle popupId={`${this.deviceAndDifficulty}bvtverdelenlesmateriaal`} tag={'h3'}/>
              </div>
              <GameMaterials items={this.state.gameMaterials} />
              <div className="spacing-20" />
            </div>
          </div>
          <div className={'column-portal'}>
            <div className="content-block">
              <div className={'title-container'}>
                <PopupTitle popupId={`${this.deviceAndDifficulty}bvtfeedbackenverdeling`} tag={'h3'}/>
              </div>
              <div className={'group-rows-container'}>
                {
                  schoolClass.Groups.map((group) => {
                    let saved = false;
                    const currentRound = group.Rounds[group.Rounds.length - 1];
                    if (currentRound && currentRound.gameStateInput && ["SUBMITTED", "PROCESSED"].includes(currentRound.gameStateInput.SIMULATION_SPENDING)) {
                      saved = true;
                    }
                    return <GroupRow key={group.id} text={__(group.name)} color={group.GroupTheme.color} onClick={() => { this.loginAsGroup(group.id); }} saved={saved} />
                  })
                }
              </div>
            </div>
          </div>
        </div>
        {this.state.confirmEnd ?
          <PopUp
            title={__('sim_verdelen_beeindigen')}
            description={__('sim_bevestig_verdelen_beeindigen_melding')}
            showPopUp={true}
            closePopUpCross={true}
            customButton={{
              text: __('sim_verdelen_beeindigen'),
              action: () => this.confirmEnd(),
            }}
            closePopUpClick={(ev) => {
              if (ev && ev.target && ['span', 'button'].includes(ev.target.tagName.toLowerCase())) {
                return false;
              }
              this.setState({confirmEnd: false});
            }}
          />
          :
          ''
        }
        {this.state.confirmPopup && this.state.confirmPopup.name ? (
          <PopUp id={this.state.confirmPopup.name} closePopUpClick={(res) => {
            if (res && typeof this.state.confirmPopup.action === 'function') {
              this.state.confirmPopup.action();
            }
            this.setState({ confirmPopup: { action: () => {}, name: '' } });
          }}/>
        ) : null}
    </div>
    );
  }
}

export default connect(({project, schoolClass, gameState}) => ({
  project,
  schoolClass,
  gameState,
}))(Verdienen);



// WEBPACK FOOTER //
// ./src/components/routes/Verdelen.js